import React from 'react';
import {BlogExcerpt, Input, OverflowStealthScroll} from "@varymadellc/my-weed-club-component-library";
import router from 'next/router';
import {urlHost} from "@/utils/apiUrl";
import Head from "next/head";
import BlogMenu from '@/layout/nav/BlogMenu';
import Page from "@/layout/Page";

export default function BlogPost({error, posts}: any) {
    const [search, setSearch] = React.useState<string>('');

    if (error) return <Page>{error}</Page>;

    const searchHandler = (event: any) => {
        setSearch(event.target.value);
    };

    return (
        <Page title="Blog" menu={
            <OverflowStealthScroll>
                <BlogMenu searchHandler={searchHandler}/>
            </OverflowStealthScroll>
        }>
            <Head>
                <title>Myweed.club - blog</title>
                <meta name="description" content="Myweed.club blog"/>
                <meta name="keywords"
                      content="myweed, myweed.club, lounge, blog, weed, cannabis, marijuana, cannabis blog, marijuana blog, weed blog"/>
            </Head>
            <div className="min-h-[600px] flex flex-col gap-y-8 gap-x-2 mx-auto">
                {
                    posts &&
                    Array.isArray(posts) &&
                    posts.filter((post) => {
                        return post.title.toLowerCase().indexOf(search.toLowerCase()) !== -1
                            || post.body.toLowerCase().indexOf(search.toLowerCase()) !== -1;
                    }).map((post: any) => {
                        if (!post) return null;

                        return (
                            <BlogExcerpt onClick={() => router.push(`/blog/view/${post.slugTitle || post.uuid}`)}
                                         wrapTitle={(title: any) => {
                                             return <span>{title}</span>
                                         }} key={post.slugTitle || post.uuid}
                                         className="w-full cursor-pointer"
                                         post={post}/>
                        )
                    })
                }
            </div>
        </Page>
    )
}

export async function getServerSideProps() {
    const url = `${urlHost}/post/published`;

    const res = await fetch(url);

    const {error, posts} = await res.json();

    if (error) {
        return {
            props: {
                error,
            }
        }
    }

    return {
        props: {
            posts: posts,
        },
    }
}